(ns manatee.qa.subs
  (:require [manatee.qa.app-db :as db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::submission-type
 (fn submission-type
   [db _]
   (or (db/get-submission-type db)
       :edit)))

(rf/reg-sub
 ::viewed-items
 (fn viewed-items
   [db _]
   (or (:viewed-items db)
       #{})))

(rf/reg-sub
 ::edit
 (fn edit
   [db _]
   (db/get-edit db)))

(rf/reg-sub
 ::comparate-edits
 (fn comparate-edits
   [db _]
   (db/get-comparate-edits db)))

(rf/reg-sub
 ::edit-user-id
 (fn edit-user-id
   [db _]
   (db/get-edit-user-id db)))

(rf/reg-sub
 ::item
 (fn item
   [db _]
   (db/get-item db)))

(rf/reg-sub
 ::item-group
 (fn item-group
   [db _]
   (db/get-item-group db)))

(rf/reg-sub
 ::comparate-item-groups
 (fn comparate-item-groups
   [db]
   (db/get-comparate-item-groups db)))

(rf/reg-sub
 ::qa-loading
 (fn qa-loading
   [db _]
   (db/get-qa-loading db)))
